import { useEffect, useState } from "react";
import { Viewer } from "../../../viewer/viewer";
import { getThumbnailImage } from "../../../viewer/ifc/ifcThumbnailRenderer";

type Props = {
  viewer: Viewer;
  url: string | null;
  size?: number;
};

/**
 * 静的な IFC サムネイル画像。以前はセルごとにライブ 3D canvas を持って手動回転
 * できたが、1000 件では重い。ここでは url ごとに 1 度だけレンダリングした PNG
 * (getThumbnailImage がキャッシュ) を <img> で表示する。同一 IFC は全セルで
 * 同じ画像を共有し、WebGL コンテキストもレンダリングも 1 回で済む。
 */
export const IfcThumbnail = ({ url, size = 80 }: Props) => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    setSrc(null);
    if (!url) return;
    getThumbnailImage(url, size)
      .then((dataUrl) => {
        if (alive) setSrc(dataUrl);
      })
      .catch(() => {
        /* 読み込み失敗時は空表示 */
      });
    return () => {
      alive = false;
    };
  }, [url, size]);

  return (
    <div
      style={{
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#1c1c1c",
        borderRadius: "2px",
      }}
    >
      {src ? (
        <img
          src={src}
          alt=""
          width={size}
          height={size}
          draggable={false}
          style={{ objectFit: "contain", pointerEvents: "none" }}
        />
      ) : null}
    </div>
  );
};
